//v3.4.2
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./style/base.scss";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/theme/element/index.css";
Vue.use(ElementUI);

import "@/directive/vdown"; //禁止浏览器预览 直接下载

import axios from "axios";
Vue.prototype.$axios = axios;

import VueCookies from "vue-cookies";
Vue.prototype.$cookie = VueCookies;

import qs from "qs";
Vue.prototype.$qs = qs;

import md5 from "js-md5";
Vue.prototype.$md5 = md5;

// 引入moment日期格式化
import moment from "moment";

Vue.use(moment);
// Vue.use(dragVerify);
// 添加过滤器实现日期格式化
Vue.filter("fmtDate", (value, fmtStr) => {
  return moment(value).format(fmtStr);
});

import slideVerify from "vue-monoplasty-slide-verify";
Vue.use(slideVerify);

import TDesign from "tdesign-vue";
import "tdesign-vue/es/style/index.css";

// 2. 保存 TDesign 原始的 install 方法
const originalTDesignInstall = TDesign.install;

// 3. 自定义 TDesign 的 install 方法
TDesign.install = function (Vue, options) {
  // 调用原始的 install 方法（注册所有 TDesign 组件和全局方法）
  originalTDesignInstall.call(this, Vue, options);

  // 将 TDesign 的 $message 重命名为 $tdMessage
  Vue.prototype.$tdMessage = Vue.prototype.$message;
  // 恢复 Element UI 的 $message（因为 TDesign 的 install 覆盖了它）
  Vue.prototype.$message = ElementUI.Message;
};

import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

Vue.use(TDesign);
Vue.prototype.$EventBts = new Vue();

import realUrl from "./conf/index.vue";
Vue.prototype.$RealUrl = realUrl;

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
